<template class="pageUser">
  <div class="page-user">
    <!--end modal-->

    <b-form @submit.prevent="sendData()" class=" mt-5">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-6">
          <b-card class="card-add custom">
            <template slot="header">
              <h2>{{ $t('Dane urządzenia') }}</h2>
            </template>
            <b-card-text>
              <div class="row">
                <div class="col-6">
                  <label><span>* </span>{{ $t('ID urządzenia:') }}</label>
                  <treeselect :normalizer="unitsNormalizer"
                              v-model="device.unit.id"
                              :placeholder="$t('Wybierz urządzenie...')"
                              :options="units"
                              :class="`custom mb-3 ` + (!formSubmited || validateState('device.unit.id') ? `` : `danger`)"
                              name="device.unit.id"
                              key="device.unit.id"
                              :noOptionsText="$t('Brak wolnych ID urządzeń')"
                              v-validate="{'required':true}"/>
                </div>
                <div class="col-6">
                  <label><span>* </span>{{ $t('Rodzaj urządzenia') }}</label>

                  <treeselect :placeholder="$t('Wybierz rodzaj...')"
                              v-model="device.unitType.id"
                              :options="unitTypes"
                              :normalizer="globalNormalizer"
                              :class="`custom mb-3 ` + (!formSubmited || validateState('device.unitType.id') ? `` : `danger`)"
                              name="device.unitType.id"
                              key="device.unitType.id"
                              :noOptionsText="$t('Brak danych')"
                              v-validate="{'required':true}"/>
                </div>
                <div class="col-12">
                  <label><span>* </span>{{ $t('Firma:') }}</label>
                  <treeselect :normalizer="globalNormalizer"
                              :placeholder="$t('Wybierz firmę...')"
                              v-model="device.company.id"
                              :options="companies"
                              :class="`custom mb-3 ` + (!formSubmited || validateState('device.company.id') ? `` : `danger`)"
                              name="device.company.id"
                              key="device.company.id"
                              :noOptionsText="$t('Brak danych')"
                              v-validate="{'required':true}"/>
                </div>

                <div class="col-12">
                  <label><span>* </span>{{ $t('Placówka:') }}</label>
                  <treeselect :normalizer="outpostNormalizer"
                              :placeholder="$t('Wybierz placówkę...')"
                              v-model="device.outpost.id"
                              :options="outposts"
                              :class="`custom mb-3 ` + (!formSubmited || validateState('device.outpost.id') ? `` : `danger`)"
                              name="device.outpost.id"
                              key="device.outpost.id"
                              :noOptionsText="$t('Brak danych')"
                              v-validate="{'required':true}"/>
                </div>

                <div class="col-12">
                  <label>{{ $t('Rodzaj toalety:') }}</label>
                  <treeselect :normalizer="globalNormalizer"
                              :placeholder="$t('Wybierz płacówkę...')"
                              v-model="device.unitLocation.id"
                              :noOptionsText="$t('Brak danych')"
                              :options="unitLocations" class="custom mb-3"/>
                </div>
                <div class="col-12">
                  <label for="sim">{{ $t('Karta SIM:') }}</label>
                  <div class="input-group input-select custom lg">
                    <treeselect :normalizer="codeNormalizer"
                                :placeholder="$t('+XX')"
                                v-model="device.simCodePrefix"
                                :noOptionsText="$t('Brak danych')"
                                :options="countries" class="custom mb-3 w-25"/>
                    <input type="number" class="form-control custom"
                           id="sim"
                           v-model="device.simCode">
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-6 ">
          <div class="row justify-content-between">
            <div class="col-4 d-flex">
              <b-link class="custom btn-link align-self-center ml-3"
                      @click="showConfirmCancelModal()"
              >{{$t('Anuluj')}}
              </b-link>

            </div>
            <div class="col-4 pl-2">
              <b-button type="submit"
                        variant="primary"
                        class="custom"
                        block>{{$t('Zapisz')}}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-form>

    <confirmCancelModal></confirmCancelModal>
  </div>
</template>

<script>
import confirmCancelModal from '@/components/Modals/ConfirmCancelModal'
import EventBus from '@/event-bus.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  name: 'Device',
  data () {
    return {
      codeNormalizer (node) {
        return {
          id: node.code,
          label: node.code
        }
      },
      globalNormalizer (node) {
        return {
          id: node.id,
          label: node.title
        }
      },
      unitsNormalizer (node) {
        return {
          id: node.id,
          label: node.unitId
        }
      },
      outpostNormalizer (node) {
        return {
          id: node.id,
          label: node.outpostId + ` (${node.mainAddress}, ${node.postalCode}, ${node.city})`
        }
      },
      returnPath: 'admin.devices',
      formSubmited: false,
      phonesError: false,
      device: {
        company: { id: null },
        unit: { id: null },
        unitType: { id: null },
        unitLocation: { id: null },
        outpost: { id: null },
        simCode: null,
        simCodePrefix: null
      },
      deviceUnit: null
    }
  },
  components: { Treeselect, confirmCancelModal },
  methods: {
    ...mapActions(['getCompanies', 'getUnits', 'getUnitTypes', 'getOutposts', 'getUnitLocations', 'getCountries']),
    sendData () {
      this.formSubmited = true
      this.$validator.validateScopes().then((result) => {
        if (result) {
          let newStep = this.currentStep + 1
          if (newStep <= this.maxStep) {
            this.currentStep = newStep
            this.formSubmited = false
          } else {
            this.$store.dispatch('sendDeviceData', this.device).then(resp => {
              this.$router.push({ name: this.returnPath })
            })
          }
        }
      })
    },
    showConfirmCancelModal () {
      EventBus.$emit(`SHOW_CONFIRM_CANCEL_MODAL`, { returnPath: this.returnPath })
    },
    validateState (ref) {
      if (
        this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    }
  },
  computed: {
    countries () {
      return this.$store.getters.countries
    },
    companies () {
      return this.$store.getters.companies
    },
    units () {
      let units = _.cloneDeep(this.$store.getters.units, true)
      let app = this
      let isDefined = false
      if (this.deviceUnit !== null && this.deviceUnit !== undefined) {
        units.map(function (item) {
          if (item.id === app.deviceUnit.id) {
            isDefined = true
          }
        })
        if (!isDefined) {
          units.push(app.deviceUnit)
        }
      }
      return units
    },
    unitTypes () {
      return this.$store.getters.unitTypes
    },
    unitLocations () {
      return this.$store.getters.unitLocations
    },
    outposts () {
      return this.$store.getters.outposts
    },
    deviceId () {
      return this.$route.params.id
    }
  },
  watch: {
    'device.company.id' (val) {
      if (val === null || val === undefined) {
        this.$store.commit('setOutposts', [])
      }
      this.getOutposts({ companyId: val })
    }
  },
  created () {
    this.getCountries()
    this.getCompanies()
    this.getUnits({ withoutCompany: true })
    this.getUnitTypes()
    this.getUnitLocations()
    this.$store.commit('setOutposts', [])

    if (this.deviceId !== undefined && this.deviceId !== null && this.deviceId !== '') {
      this.$store.dispatch('getDevice', { id: this.deviceId }).then(response => {
        if (response.id === undefined) {
          this.$router.push({ name: this.returnPath })
        }
        this.device = response
        if (response.unit !== null && response.unit.id !== null) {
          this.deviceUnit = response.unit
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
